<template>
  <div class="backdrop">
    <div class="backdrop-top">
      <div class="title-box">
        <img src="../../../assets/images/return.png" @click="$router.go(-1)"><span>{{title}}</span>
      </div>
      <div class="common head-wrapper">
        <div v-if="repair_status" class="layout row">
          <label>关联维修单：</label>
          <span class="flex-1">{{repair_uid}}</span>
        </div>
        <div class="layout row">
          <label>小区：</label>
          <span class="flex-1">{{villageName}}</span>
        </div>
        <div class="layout row">
          <label>仓库：</label>
          <span class="flex-1" @click="warehouseClick()"><span v-html="storage_name" :style="[storage_name == '请选择仓库' ? {'color': '#7090fd'} : '']"></span><img class="warearrow" src="../../../assets/images/right_jt.png"></span>
        </div>
        <div class="layout row">
          <label>商品种类：{{total_goods_kind}} 商品数量：{{total_goods_count}}</label>
        </div>
        <!-- 上传图片 -->
        <div class="uploadImg">
          <div class="uploadImgFile">
            <input class="uploadImg" @change="uploadFile" type="file">
          </div>
          <div class="uploadImgList" v-for="(image, image_key) in imageList" :key="image_key">
            <img class="img" :src="image" @click="previewImage(image)">
            <img class="del" @click="deleteImage(image_key)" src="../../../assets/images/repairman-del.png">
          </div>
        </div>
        <!-- 预览图片 -->
        <div class="previewimg" v-if="previewFile">
          <div @click="previewclose"></div>
          <img :src="previewimg">
        </div>
      </div>
      <div class="common remarks-wrapper">
        <div>备注</div>
        <div class="remarks-textarea">
          <textarea v-model="remarks" placeholder="请输入备注"></textarea>
        </div>
      </div>
    </div>
    <div class="backdrop-bottom">
      <button class="entry-btn" @click="commit">保存草稿</button>
      <!-- <button class="entry-btn">入账</button> -->
    </div>
    <!-- 选择仓库弹出框 -->
    <div class="warehouselist" v-if="warehouseList">
      <div class="warehouselist-top" @click="clickBlank"></div>
      <div class="warehouselist-bottom">
        <el-tree :data="warehouseData" :props="defaultProps" :expand-on-click-node="false" node-key="id" @node-click="selectStorage"></el-tree>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'InvoiceAdd',
  metaInfo: {
    title: '物资管理'
  },
  computed: {
    ...mapState(['villageId', 'villageName', 'memberId'])
  },
  data () {
    return {
      imageList: [], // 保存图片集合
      imageListId: [], // 选中的图片id
      previewimg: '', // 预览图片
      previewFile: false, // 预览默认关闭
      maxSize: 500, // 上传图片限制最大为500kb
      formData: '',
      access_token: '', // tob access_token
      warehouseList: false, // 选择仓库弹出框
      repair_uid: '',
      warehouseData: [],
      storage_name: '请选择仓库',
      storage_id: 0,
      remarks: '',
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      total_goods_kind: 0,
      total_goods_count: 0,
      repair_status: false,
      invoice_info: [],
      operate_log: [],
      uploadFileStatus: true
    }
  },
  created () {
    console.log(this.$route)
    this.getAccessToken()
    this.invoice_id = this.$route.query.invoice_id
    this.repair_id = this.$route.query.repair_id
    this.delivery_type_id = this.$route.query.delivery_type_id
    this.selecte_goods_lists = JSON.parse(this.$route.query.selecteLists)
    this.title = this.$route.query.title_info
    if (this.selecte_goods_lists === undefined || Object.keys(this.selecte_goods_lists).length === 0) {
      this.$toast({
        message: '请选择商品',
        duration: 5000
      })
      this.$router.push({name: 'SelecteGoods', query: {repair_id: this.repair_id, delivery_type_id: this.delivery_type_id}})
    } else {
      this.total_goods_kind = Object.keys(this.selecte_goods_lists).length// 商品种类
      for (var key of Object.keys(this.selecte_goods_lists)) {
        this.total_goods_count = parseFloat(this.selecte_goods_lists[key]['goods_count']) + parseFloat(this.total_goods_count) // 总件数
      }
    }
    if (this.invoice_id !== undefined) {
      this.getInvoiceInfo()
    }
    this.getRepair(this.repair_id)
    this.getStorageTree()
  },
  methods: {
    getInvoiceInfo () {
      this.axios.post('/wechat/Invoice/getInvoiceInfo', {
        member_id: this.memberId,
        village_id: this.villageId,
        invoice_id: this.invoice_id
      }).then((res) => {
        console.log('getInvoiceInfo:')
        console.log(res.data)
        if (res.data.status === 1) {
          this.invoice_info = res.data.data
          this.storage_name = this.invoice_info.storage_name
          this.storage_id = this.invoice_info.storage_id
          this.remarks = this.invoice_info.remark
          if (this.invoice_info.pictures) {
            for (var j = 0; j < this.invoice_info.pictures.length; j++) {
              this.imageList = this.imageList.concat(this.invoice_info.pictures[j]['picture_url'])
              this.imageListId = this.imageListId.concat(this.invoice_info.pictures[j]['picture_id'])
            }
          }
        }
      }).catch(() => {
        this.loading = false
        this.$toast({
          message: '网络错误',
          duration: 5000
        })
      })
    },
    getRepair (repairId) {
      this.axios.get('/wechat/repair/getRepairInfo/village_id/' + this.villageId + '/repair_id/' + repairId)
        .then((res) => {
          if (res.data.status === 1) {
            console.log('getRepairInfo:')
            console.log(res)
            this.repair_uid = res.data.data.repair_uid + '（ ' + res.data.data.status + ' ）'
          }
        }).catch(() => {
          this.$toast({
            message: '网络错误',
            duration: 5000
          })
        })
    },
    getStorageTree () {
      this.axios.post('/wechat/basic_info/getStorageTree', {
        member_id: this.memberId,
        village_id: this.villageId
      }).then((res) => {
        if (res.data.status === 1) {
          this.warehouseData = res.data.data
          console.log('this.warehouseData:')
          console.log(this.warehouseData)
        }
      })
    },
    commit () {
      if (this.storage_id === 0) {
        this.$toast({
          message: '请选择仓库',
          duration: 3000
        })
        return false
      }
      if (this.goods_lists === {}) {
        this.$toast({
          message: '请选择商品',
          duration: 3000
        })
        return false
      }
      if (this.uploadFileStatus === false) {
        this.$toast({
          message: '上传图片未完成，请稍后再试',
          duration: 3000
        })
        return false
      }
      console.log('提交')
      console.log(this.storage_id)
      console.log(this.imageListId)
      console.log(this.remarks)
      this.axios.post('/wechat/Invoice/addInvoice', {
        member_id: this.memberId,
        village_id: this.villageId,
        delivery_type_id: this.delivery_type_id,
        invoice_id: this.invoice_id,
        repair_id: this.repair_id,
        storage_id: this.storage_id,
        imageListId: this.imageListId,
        remarks: this.remarks,
        goods_lists: this.selecte_goods_lists
      }).then((res) => {
        if (res.data.status === 1) {
          this.$toast({
            message: '操作成功',
            duration: 5000
          })
          this.$router.push({name: 'InvoiceList', query: {delivery_type_id: this.delivery_type_id, title_info: this.title}})
          // this.$router.go(-1)
        } else {
          this.$toast({
            message: res.data.message,
            duration: 5000
          })
        }
      }).catch(() => {
        this.$toast({
          message: '网络错误',
          duration: 5000
        })
      })
    },
    selectStorage (data) {
      this.storage_id = data.id
      this.storage_name = data.label
      this.clickBlank()
    },
    warehouseClick () {
      this.warehouseList = true
    },
    clickBlank () {
      this.warehouseList = false
    },
    // 选择上传图片
    uploadFile (e) {
      if (this.imageList.length < 9) {
        let that = this
        that.uploadFileStatus = false
        var files = e.target.files[0]

        var reader = new FileReader()
        reader.readAsDataURL(files)
        // 监听文件读取结束后事件
        reader.onloadend = function (e) {
          // var dx = (e.total / 1024) / 1024
          // if (dx >= 2) {
          //   alert('文件大小大于2M')
          //   return
          // }
          that.imageList.push(e.target.result)

          let img = new Image()
          img.src = reader.result
          img.onload = () => {
            // 以上是将选择的图片展示出来
            let originWidth = img.naturalWidth
            let originHeight = img.naturalHeight
            let originSize = files.size / 1024 // 计算图片多少kb
            // 将图片绘制到canvas上进行压缩
            let canvas = document.createElement('canvas')
            let context = canvas.getContext('2d')
            let maxSize = that.maxSize
            if (originSize <= maxSize) {
              that.formData = new FormData() // 声明一个FormData对象
              that.formData.append('file', files)
            } else {
              let mul = originSize / maxSize
              let targetWidth = originWidth / mul
              let targetHeight = originHeight / mul
              canvas.width = targetWidth
              canvas.height = targetHeight
              context.clearRect(0, 0, targetWidth, targetHeight) // 清除画布
              context.drawImage(img, 0, 0, targetWidth, targetHeight) // 画图

              let dataURL = canvas.toDataURL('image/jpeg') // 将其转化成base64字符串
              let blob = that.dataURItoBlob(dataURL) // 转化为blob格式
              var fileName = new Date().getTime() + '.jpeg'

              that.formData = new FormData() // 声明一个FormData对象
              that.formData.append('file', blob, fileName)
            }
            var options = { // 设置axios的参数
              url: '/api/Upload/uploadpicture?access_token=' + that.access_token,
              data: that.formData,
              method: 'post',
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }
            that.axios(options).then((res) => {
              that.imageListId = that.imageListId.concat(res.data.data.id)
              that.uploadFileStatus = true
              console.log('that.imageList')
              console.log(that.imageListId)
              console.log(that.imageList)
            })
          }
        }
      } else {
        this.$toast({
          message: '最多选择9张图片',
          duration: 5000
        })
      }
      e.target.value = '' // 解决input type=file 同一个文件二次上传无效的问题
    },
    // base64格式转化为blob对象
    dataURItoBlob (dataURI) {
      let byteString = atob(dataURI.split(',')[1])
      let mimeString = dataURI
        .split(',')[0]
        .split(':')[1]
        .split(';')[0]
      let ab = new ArrayBuffer(byteString.length)
      let ia = new Uint8Array(ab)
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i)
      }
      return new Blob([ab], { type: mimeString })
    },
    // 删除上传图片
    deleteImage (e) {
      this.imageList.splice(e, 1)
      this.imageListId.splice(e, 1)
    },
    // 预览图片
    previewImage (e) {
      this.previewFile = true
      this.previewimg = e
    },
    // 关闭预览
    previewclose () {
      this.previewFile = false
    },
    // 获取tob accessToken
    getAccessToken () {
      this.axios.get('/wechat/repair/tobAccessToken')
        .then((res) => {
          if (res.data.status === 1) {
            this.access_token = res.data.data.access_token
          }
        }).catch(() => {
          this.$toast({
            message: '网络错误',
            duration: 5000
          })
        })
    }
  }
}
</script>
<style scoped>
.common {
  padding: 10px 15px;
}
.backdrop {
  overflow: hidden;
}
.backdrop-top {
  height: calc(100% - 50px);
  overflow-y: auto;
}
.head-wrapper {
  font-size: 15px
}
.head-wrapper .row {
  line-height: 28px;
}
.head-wrapper .row label {
  width: 125px;
}
.head-wrapper .warearrow {
  width: 12px;
  height: 12px;
  margin-left: 15px;
}
.remarks-wrapper {
  color: #969696;
}
.remarks-wrapper .remarks-textarea {
  display: flex;
}
.remarks-wrapper .remarks-textarea textarea {
  flex: 1;
  border: none;
  padding: 15px 0;
  outline: none;
  color: #c2c2c2;
  font-size: 14px;
  min-height: 50px;
}
.remarks-wrapper .remarks-textarea textarea::-webkit-input-placeholder{
  color:#c2c2c2;
}
.backdrop-bottom {
  height: 50px;
  background-color: #ffffff;
  display: flex;
}
.backdrop-bottom button {
  flex: 1;
  height: 50px;
  line-height: 49px;
  background-color: #f0f1f3;
  border-radius: none;
  border: none;
  color: #45454d;
  font-size: 15px;
}
.backdrop-bottom .entry-btn {
  background-color: #ff7c12;
  color: #ffffff;
}
.warehouselist {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 99;
  align-items: center;
  justify-content: center;
  display: flex;
  font-size: 15px;
}
.warehouselist .warehouselist-bottom {
  background-color: #ffffff;
  width: 100%;
  position: absolute;
  bottom: 0;
}
.warehouselist-top {
  width: 100%;
  height: 100%;
}
.warehouselist .warehouselist-bottom label {
  display: block;
  padding: 8px 15px;
}
>>>
.el-tree-node__content {
  height: 36px;
}
>>>
.el-tree-node__label {
  font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/Material/Invoice/InvoiceAdd.vue